import { useContext } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { PositionDetailsModel } from "../../../apis/ApisPositions";
import { Link } from "react-router";

export type PositionCardsProps = {
    departmentFilter: string,
    roleFilter: string,
    locationFilter: string,
    PqeAndExpView: boolean,
    PqeView: boolean,
    ExpView: boolean,
    RefView: boolean,
    PracticeGroupView: boolean,
    intra: boolean,
    positions: PositionDetailsModel[],
}

export function PositionCards(props: PositionCardsProps) {
    let filteredPositions = props.positions
        .filter(x => {
            let result = true;
            if (props.departmentFilter != null && props.departmentFilter != "") {
                if (x.ExternalDepartment != props.departmentFilter) {
                    result = false;
                }
            }
            if (props.roleFilter != null && props.roleFilter != "") {
                if (x.CandidateTitle != props.roleFilter) {
                    result = false;
                }
            }
            if (props.locationFilter != null && props.locationFilter != "") {
                if (x.LocationText != props.locationFilter) {
                    result = false;
                }
            }
            return result;
        });

    return (<>
        {filteredPositions.map(x => { return positionCard({ ...props, position: x }); })}
        {filteredPositions.length == 0 && <div className="card card-body mb-3">
            <div className="d-flex flex-column text-muted text-center">
                No positions match your filter
            </div>
        </div>}
    </>);
}

type PositionCardProps = {
    PqeAndExpView: boolean,
    PqeView: boolean,
    ExpView: boolean,
    RefView: boolean,
    PracticeGroupView: boolean,
    intra: boolean,
    position: PositionDetailsModel,
}

const positionCard = (props: PositionCardProps) => {
    const app = useContext(AppContext);
    const linkUrl = `${props.intra ? "/Intranet" : ""}/PositionDetails?id=${props.position.ApplyingForID}`;
    return (<div className="card card-body mb-3" key={`PosCard_${props.position.ApplyingForID}`}>
        <div className="d-flex flex-column">
            <div className="pb-1">
                <h2><Link className="header-link" to={linkUrl}>{props.position.CandidateTitle}</Link></h2>
                <hr className="ShortBlock" />
            </div>
            {positionRow("fa-building", app.positions?.Features.DisplayText_Department, props.position.ExternalDepartment)}
            {props.PracticeGroupView && positionRow("fa-people-group", app.positions?.Features.DisplayText_PracticeGroup, props.position.PracticeGroup)}
            {positionRow("fa-location-dot", "Location", props.position.LocationText)}
            {props.PqeAndExpView && positionRow("fa-lightbulb", "PQE / Experience", `${props.position.PQERequired == null ? "" : props.position.PQERequired} ${props.position.PQERequired != null && props.position.ExperienceLevel != null ? "/" : ""} ${props.position.ExperienceLevel == null ? "" : props.position.ExperienceLevel}`)}
            {props.PqeView && positionRow("fa-lightbulb", "PQE", props.position.PQERequired)}
            {props.ExpView && positionRow("fa-lightbulb", "Experience", props.position.ExperienceLevel)}
            {props.RefView && positionRow("fa-hashtag", "Reference", props.position.ApplyingForID.toString())}
            <div className="py-2 d-flex flex-row justify-content-between">
                <Link to={linkUrl} className="btn btn-wider btn-outline-soft">Details</Link>
            </div>
        </div>
    </div>);
}

const positionRow = (iconClass: string, title: string, details: string) => {
    return (<div className="py-1 d-flex"><div className="w-50 text-alt-or-contrast"><i className={`icon-squared fa-solid ${iconClass} me-1`}></i><b>{title}:</b> </div><div className="w-50">{details}</div></div>);
}